var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SalesReportTemplate',{attrs:{"title":"Sales Report by Product","columns":_vm.columns,"permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_PRODUCT,"fetchRoute":"/reports/sales-by-product","reportTypeCode":_vm.REPORT_MASTER_CODES.SALES_BY_PRODUCT}})
}
var staticRenderFns = []

export { render, staticRenderFns }